import { marker } from '@colsen1991/ngx-translate-extract-marker';

export enum EWeekDay {
  Monday = 'monday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday',
  Thursday = 'thursday',
  Friday = 'friday',
  Saturday = 'saturday',
  Sunday = 'sunday',
}

export const WEEK_DAY_MAP = new Map<EWeekDay, { dayIdx: number; label: string }>([
  [EWeekDay.Monday, { dayIdx: 1, label: marker('common.week.monday.full') }],
  [EWeekDay.Tuesday, { dayIdx: 2, label: marker('common.week.tuesday.full') }],
  [EWeekDay.Wednesday, { dayIdx: 3, label: marker('common.week.wednesday.full') }],
  [EWeekDay.Thursday, { dayIdx: 4, label: marker('common.week.thursday.full') }],
  [EWeekDay.Friday, { dayIdx: 5, label: marker('common.week.friday.full') }],
  [EWeekDay.Saturday, { dayIdx: 6, label: marker('common.week.saturday.full') }],
  [EWeekDay.Sunday, { dayIdx: 7, label: marker('common.week.sunday.full') }],
]);
